
'use client'
import { Button } from '@/components/ui/button';
import { useState } from 'react';
import messengerImg from '@/assets/home/messenger.png'
import Image from 'next/image';
import Link from 'next/link';

const FacebookChat = () => {
    const [minimized,setMinimized] = useState<any>('true')

    return(
        <Link target='_blank' href={'https://m.me/226784787184300'} className='fixed bottom-3 right-3 p-3 rounded-full shadow-custom bg-white'>
            <Image src={messengerImg} width={35} height={35} alt='facebookchat' />
        </Link>
    )
}

export default FacebookChat